export const OfficialProductSetup:any = {
    itemType: [
      {
        id: "0",
        name: "Packaging"
      },
      {
        id: "1",
        name: "Standard"
      },
      {
        id: "2",
        name: "Warehouse Prod ING"
      },
      {
        id: "3",
        name: "Warehouse Prod FG"
      },
      {
        id: "4",
        name: "Alcohol"
      },
      {
        id: "6",
        name: "Baskets"
      },
      {
        id: "7",
        name: "Label"
      },
      {
        id: "8",
        name: "Gift cards"
      },
      {
        id: "9",
        name: "Supply items"
      },
      {
        id: "10",
        name: "Generic"
      },
      {
        id: "11",
        name: "Service items"
      }
    ],
    stockUnit: [
      {
        id: "1",
        name: "Unit/unit"
      },
      {
        id: "2",
        name: "Weight/weight"
      },
      {
        id: "3",
        name: "Unit/ Fixed weight"
      },
      {
        id: "4",
        name: "Unit / weighted"
      },
      {
        id: "5",
        name: "Unit/average weight"
      }
    ],
    invoiceUnit: [
      {
        id: "1",
        name: "Unit"
      },
      {
        id: "2",
        name: "weight unit"
      },
      {
        id: "3",
        name: "length unit"
      },
      {
        id: "4",
        name: "area unit"
      },
      {
        id: "5",
        name: "volume unit"
      }
    ],
    categoryManagerList: [
      {
        id: "36",
        categoryManager: "MANAGER 1"
      },
      {
        id: "39",
        categoryManager: "MANAGER 2"
      },
      {
        id: "42",
        categoryManager: "MANAGER 3"
      }
    ],
  }
  